import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IContactAvailableTimes } from '../contact_interfaces';

export class Contact implements IIndexable {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  relationship: string;
  relationship_type: string;
  work_phone: string;
  availability: IContactAvailableTimes;

  constructor(contact: Partial<Contact>) {
    _4.merge(this, contact);
    // This is required for backward compatibility.
    this.id = `${this.id}-${this.relationship}`;
    this.relationship = _4.get(this, 'relationship_type', this.relationship);
  }

  static build(contact: Partial<Contact>): Contact {
    return new Contact(contact);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/builders/contact_builder.ts